/* ============================================================
   Sam's Store — Transparent Header JS (Phase D)
   Adds body.sam-header-scrolled when page scrollY > 80px.
   Runs only when Liquid marks the homepage header as transparent.
   ============================================================ */
(function () {
  'use strict';

  /* Liquid adds this class only when homepage transparency is enabled. */
  var transparentHeader = document.querySelector('.header-wrapper.sam-header--transparent');
  if (!transparentHeader) return;

  var scrollThreshold = 80;
  var body = document.body;
  var headerSection = transparentHeader.closest('.section-header');
  var ticking = false;

  function updateOverlayTop() {
    if (!headerSection) return;

    var overlayTop = 0;
    var sibling = headerSection.previousElementSibling;

    while (sibling) {
      if (sibling.classList.contains('shopify-section-group-header-group')) {
        overlayTop += sibling.getBoundingClientRect().height;
      }
      sibling = sibling.previousElementSibling;
    }

    document.documentElement.style.setProperty('--sam-header-overlay-top', Math.round(overlayTop) + 'px');
  }

  updateOverlayTop();

  if ('ResizeObserver' in window) {
    var headerOffsetObserver = new ResizeObserver(updateOverlayTop);
    var offsetSibling = headerSection ? headerSection.previousElementSibling : null;

    while (offsetSibling) {
      if (offsetSibling.classList.contains('shopify-section-group-header-group')) {
        headerOffsetObserver.observe(offsetSibling);
      }
      offsetSibling = offsetSibling.previousElementSibling;
    }
  } else {
    window.addEventListener('resize', updateOverlayTop, { passive: true });
  }

  function updateHeader() {
    if (window.scrollY > scrollThreshold) {
      body.classList.add('sam-header-scrolled');
    } else {
      body.classList.remove('sam-header-scrolled');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  /* Run immediately in case page loads mid-scroll */
  updateHeader();
})();
